import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { I18nProvider } from "./i18n/useI18n";
import { AuthProvider } from "./lib/auth";
import { ContentOverridesProvider } from "./contexts/ContentOverridesContext";
import "./styles/global.css";

// ContentOverridesProvider wraps I18nProvider so that I18nProvider can call
// useContentOverrides() to merge admin-set text overrides into `t`. The
// provider fetches from site_content_overrides on mount (one SELECT, public
// RLS) and is effectively zero-cost when no overrides are set.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ContentOverridesProvider>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </ContentOverridesProvider>
  </StrictMode>
);
